//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

    props: ['url', 'item'],

    data: function data() {
        return {
            transactions: [],
            consolidated: [],
            balance: 0.00,
            accountBalances: [],
            loading: true,
            period: moment().format("MM/DD/YYYY")
        };
    },
    mounted: function mounted() {
        var _this = this;

        axios.post('/prototype/accounting/general-ledger/accounts/monthly-balances', this.item).then(function (response) {
            return _this.accountBalances = response.data;
        });
        this.balance = this.item.end_balance;
        this.refreshEntries();
    },


    methods: {
        refreshEntries: function refreshEntries() {
            var _this2 = this;

            this.loading = true;
            this.item['period'] = this.period;
            axios.post('/prototype/accounting/general-ledger/accounts/entries', this.item).then(function (response) {
                _this2.transactions = response.data;
                _this2.loading = false;
            });
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/accounts/AccountDetails.vue
// module id = H9/n
// module chunks = 0 1